import React from "react";
import { useState } from "react";

import { CometdActions } from "../../cometD/cometD-action";
import {
  disabledImgWithBtns,
  disablePreviousButton,
} from "../../helpers/index";
import { isNullOrUndefined } from "../../Simplify360Chat/HWLibrary/HWUtils";

import "./LanguageToggle.css";

export default function LanguageToggle(props) {
  const [toggle, setToggle] = useState(false);
  const languages = [
    { name: "English", value: "English" },
    { name: "தமிழ்", value: "Tamil" },
    { name: "ಕನ್ನಡ", value: "Kannada" },
    { name: "తెలుగు", value: "Telugu" },
    { name: "हिंदी", value: "Hindi" },
    { name: "മലയാളം", value: "Malayalam" },
    { name: "मराठी", value: "Marathi" },
    { name: "ਪੰਜਾਬੀ", value: "Punjabi" },
    { name: "ગુજરાતી", value: "Gujarati" },
    { name: "ଓଡିଆ", value: "Oriya" },
    { name: "বাংলা", value: "Bangla" },
  ];

  const [selectedlang, setSelectedLang] = useState(
    isNullOrUndefined(JSON.parse(sessionStorage.getItem("selectedLanguage")))
      ? JSON.parse(sessionStorage.getItem("selectedLanguage"))
      : languages[0]
  );

  React.useEffect(() => {
    const initialLang = languages[0];
    setSelectedLang(initialLang);
  }, [ ]);

  const onSelectLanguageHandle = (language) => {
    disabledImgWithBtns();
    disablePreviousButton();
    const sessionId = props?.sessionId;
    const { changeLanguageCometd } = CometdActions();
    setSelectedLang(language);
    sessionStorage.setItem("selectedLanguage", JSON.stringify(language));
    changeLanguageCometd(sessionId, language?.value);
  };

  return (
    <div className="languageToggleContainer" onClick={() => setToggle(!toggle)}>
      <h4> {selectedlang?.name}</h4>
      {toggle ? (
        <div className="toggleDropDown">
          {languages.map((oneLang) => (
            <div
              className="oneLanguage"
              onClick={() => onSelectLanguageHandle(oneLang)}
              key={oneLang.value}
            >
              {console.log("oneLang", oneLang)}
              <p>{oneLang.name}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
